import { render, staticRenderFns } from "./PostLink.vue?vue&type=template&id=cdfde5fc"
import script from "./PostLink.vue?vue&type=script&lang=js"
export * from "./PostLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports